import React from 'react'

import { Card } from '@/ui/card'
import { useWidgetChainScope, type WidgetChainScope } from '../../../config'
import { useAddLiquidityController, type AddLiquidityControllerResult } from '../../../features/liquidity/useAddLiquidityController'
import { AddRemoveTabs } from '../../../components/NavigationTabs'
import type { WidgetNavigationProps } from '../../navigation'
import { AddLiquidityForm } from './AddLiquidityForm'

export type LiquidityAddWidgetProps = WidgetNavigationProps & {
  embedded?: boolean
  chainScope?: WidgetChainScope
  children?: (controller: AddLiquidityControllerResult) => React.ReactNode
}

export default function LiquidityAddWidget({
  resolveRoute,
  embedded = false,
  chainScope,
  children,
}: LiquidityAddWidgetProps) {
  void useWidgetChainScope(chainScope)
  const controller = useAddLiquidityController(resolveRoute, chainScope)

  if (children) {
    return <>{children(controller)}</>
  }

  return (
    <>
      {!embedded && <AddRemoveTabs adding={true} />}
      <Card className="p-[var(--panel-padding)]">
        <AddLiquidityForm controller={controller} />
      </Card>
    </>
  )
}
